import { __awaiter } from "tslib";
/**
 * 车辆图片集合
 */
import { createStore } from '@souche-f2e/muji';
import API from '@/services';
import { judgeObj, judgeArr } from '@/shared/functions';
export default createStore({
    state: {
        imgs: [],
    },
    effects: {
        // desc 获取车辆图片集合 payload: {reportCode}
        getCarImgs(payload, store) {
            return __awaiter(this, void 0, void 0, function* () {
                const { reportCode, defaultImg } = payload;
                if (defaultImg) {
                    this.SET_STATE({
                        imgs: defaultImg,
                    });
                }
                else {
                    this.SET_STATE({
                        imgs: [],
                    });
                }
                API.uniApi.getCarImgesData({ reportCode }).then((res) => {
                    if (judgeObj(res.data)) {
                        const { photoList } = res.data;
                        if (judgeArr(photoList)) {
                            this.SET_STATE({
                                imgs: photoList,
                            });
                        }
                    }
                });
            });
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload).forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
    },
});
